import React from 'react';
import First from './Sections/First';

const AboutCourse = () => {
    return (
        <main>
            <First />
        </main>
    );
};

export default AboutCourse;